import { FC, PropsWithChildren } from 'react'
import { BottomMenu } from '../general/navigation/bottom'
import { IssueFeedMock } from '../feed/feed-mock'

/* Dashboard inner component horizontal containers with issue feed */
export const DashboardInnerMock: FC<PropsWithChildren<{ demo?: boolean }>> = ({
  children,
  demo,
}) => {
  return (
    <>
      <div className={'flex-1 px-3 md:px-4 overflow-auto'}>
        {children}
        <BottomMenu />
      </div>
      <IssueFeedMock demo={demo} />
    </>
  )
}
